import tw from "twin.macro";
import styled from "styled-components";

export const List = styled.ul(tw`rounded bg-white p-0 m-0 list-none`);
export const Li = styled.li(
  tw`px-6 py-4 border-0 border-b last:border-b-0 border-solid border-secondary `
);
